import React from 'react';
import { Container } from 'styles';
import { copyFor } from 'config';
import { Text } from '@perch-labs/shrike';
import SolarFarmImgSrc from '/images/solar/solar-farm.png';
import {
  ContentContainer,
  Header,
  StepContainer,
  StepNumberBox,
  StepNumber,
  VerticalBar,
} from './project-timeline.style';

const getCopy = copyFor('solar.projectTimeline');

interface Props {
  launchDate: string;
}

export const ProjectTimeline = ({ launchDate }: Props) => {
  return (
    <Container flex direction="column">
      <Text textStyle="heading700" tag="h2" margin="16px 0">
        {getCopy('title')}
      </Text>
      <Container flex>
        <StepContainer>
          <StepNumberBox>
            <StepNumber>1</StepNumber>
          </StepNumberBox>
          <VerticalBar />
        </StepContainer>
        <ContentContainer>
          <Header>{getCopy('enrollment.title')}</Header>
          <Text>{getCopy('enrollment.subTitle')}</Text>
        </ContentContainer>
      </Container>
      <Container flex>
        <StepContainer>
          <StepNumberBox>
            <StepNumber>2</StepNumber>
          </StepNumberBox>
          <VerticalBar />
        </StepContainer>
        <ContentContainer>
          <Header>{getCopy('construction.title')}</Header>
          <Text>{getCopy('construction.subTitle')}</Text>
        </ContentContainer>
      </Container>
      <Container flex>
        <StepContainer>
          <StepNumberBox>
            <StepNumber>3</StepNumber>
          </StepNumberBox>
        </StepContainer>
        <ContentContainer>
          <Header>{getCopy('launch.title', { launchDate })}</Header>
          <Text margin={{ bottom: '16px' }}>{getCopy('launch.subTitle')}</Text>
          <img src={SolarFarmImgSrc} />
        </ContentContainer>
      </Container>
    </Container>
  );
};
